/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { isNullOrWhitespace, ValidationProps } from '@amzn/dots-core-ui';
import { useClient, DevicePool } from '$/api';
import { CoreAsyncSelect, CoreAsyncSelectProps } from './CoreAsyncSelect';

export type DevicePoolSelectProps = Pick<
  ValidationProps<CoreAsyncSelectProps<DevicePool>>,
  'value' | 'onChange' | 'errorMessage' | 'validationState'
>;

export const DevicePoolSelect = (props: DevicePoolSelectProps): JSX.Element => {
  const { devicePools } = useClient();
  const getTypes = async (query: string): Promise<DevicePool[]> => {
    if (isNullOrWhitespace(query)) {
      return [];
    }
    const { content } = await devicePools.getAll({
      name: query,
      fuzzySearch: true,
    });
    return content;
  };
  return (
    <CoreAsyncSelect
      {...props}
      label="Device Pool(s)"
      getItems={getTypes}
      getItemLabel={(item): string => item.name}
      getItemValue={(item): number => item.id}
    />
  );
};
